import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { collection, limit, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../firebase/config";
import {
  getActiveRelevantCommunityAlerts,
  getCommunityAlertCountLabel,
  hasUsableCommunityAlertViewerLocation,
} from "../../utils/communityAlerts";

export const CommunityAlertBarView = ({ alerts = [], hasViewerLocation = false }) => {
  if (alerts.length === 0) return null;

  const label = getCommunityAlertCountLabel(alerts.length, {
    nearby: hasViewerLocation,
  });

  return (
    <Link
      to="/community/alerts"
      className="community-alert-bar"
      aria-label={`${label}. View alerts.`}
    >
      <span aria-hidden="true" className="community-alert-bar-icon">
        !
      </span>
      <strong>{label}</strong>
      <span>View alerts &rarr;</span>
    </Link>
  );
};

const CommunityAlertBar = ({ currentUser, userLocation, userProfile }) => {
  const [alertPosts, setAlertPosts] = useState([]);

  useEffect(() => {
    if (!currentUser?.uid) {
      setAlertPosts([]);
      return undefined;
    }

    const alertsQuery = query(
      collection(db, "communityPosts"),
      where("alertStatus", "==", "active"),
      limit(50)
    );

    const unsubscribe = onSnapshot(
      alertsQuery,
      (snapshot) => {
        setAlertPosts(snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })));
      },
      (error) => {
        console.error("Community alert bar listener failed:", error);
        setAlertPosts([]);
      }
    );

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [currentUser?.uid]);

  const relevantAlerts = useMemo(
    () => getActiveRelevantCommunityAlerts(alertPosts, userLocation || userProfile || {}),
    [alertPosts, userLocation, userProfile]
  );
  const hasViewerLocation = hasUsableCommunityAlertViewerLocation(
    userLocation || userProfile || {}
  );

  if (!currentUser?.uid) return null;

  return (
    <CommunityAlertBarView
      alerts={relevantAlerts}
      hasViewerLocation={hasViewerLocation}
    />
  );
};

export default CommunityAlertBar;
